import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Role } from '../../../../../models/Role';
import { PermissionsService } from '../../../../../services/permissions.service';
import { Logger } from '../../../../../../../infrastructure/logging/logger';

@Component({
  selector: 'app-create-role-dialog',
  templateUrl: './create-role-dialog.component.html',
  styleUrls: ['./create-role-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatProgressSpinner
  ]
})
export class CreateRoleDialogComponent {

  form: FormGroup;
  saving = false;

  constructor(
    private formBuilder: FormBuilder,
    private permissionsService: PermissionsService,
    private logService: Logger,
    public dialogRef: MatDialogRef<CreateRoleDialogComponent, Role>
  ) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern(/[\S]/)]]
    });
  }

  // Saves here rather than in the caller so the dialog stays open (with the typed name) if the save fails.
  async onSaveClick(): Promise<void> {
    if (this.form.invalid || this.saving) {
      return;
    }

    try {
      this.saving = true;
      const name = (this.form.value.name as string).trim();
      const role = await this.permissionsService.createRole(name);
      this.dialogRef.close(role);
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while creating the Role', 'Error while creating Role');
    } finally {
      this.saving = false;
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
